import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/deck-shuffle/opening-cards.png")